import {
  SUPPORT_SEND_REQUEST,
  SUPPORT_SEND_SUCCESS,
  SUPPORT_SEND_FAIL,
  SUPPORT_SEND_RESET,
} from "../Constants/SupportConstants";

// SUPPORT UPSERT
export const supportSendReducer = (state = {}, action) => {
  switch (action.type) {
    case SUPPORT_SEND_REQUEST:
      return { loading: true };
    case SUPPORT_SEND_SUCCESS:
      return { loading: false, success: true, recordItem: action.payload };
    case SUPPORT_SEND_FAIL:
      return { loading: false, error: action.payload };
    case SUPPORT_SEND_RESET:
      return {};
    default:
      return state;
  }
};
